import {useLocation} from '@github-ui/react-router'

import type {ImmersivePlugin} from '../plugin/copilot-immersive-plugin'
import {getActivePluginFromLocation} from '../plugin/get-active-plugin-from-location'
import {usePlugins} from '../plugin/ImmersivePluginsProvider'

export function useActivePlugin(): ImmersivePlugin | undefined {
  const plugins = usePlugins()
  const location = useLocation()

  return getActivePluginFromLocation(location, plugins)
}
